var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getOperationAST, visit, print, OperationTypeNode, } from "graphql";
import gql from "graphql-tag";
import { useQuery, useLazyQuery, } from "@apollo/client";
import * as Result from "core/utils/Result";
import * as Either from "fp-ts/lib/Either";
/**
 * @NOTE This function drops all extra information contained
 * within an ApolloError. We simply use the `message` property
 * here.
 *
 * @NOTE In the past we first checked the loading state before
 * anything else. This was correct in v2.6. In v3.0 they changed
 * this logic for some reason. When refetching and data is
 * present, loading is true for some reason.

 * For more info read this issue report:
 * https://github.com/apollographql/apollo-client/issues/6631
 *
 * @TODO This is just a quick fix.
 * We might need to change the way we do SSR.
 */
export function queryResultToResult(queryResult) {
    if (queryResult.error) {
        return Result.fail(queryResult.error.message);
    }
    if (typeof queryResult.data !== "undefined") {
        return Result.success(queryResult.data);
    }
    if (queryResult.loading) {
        return Result.loading;
    }
    return Result.fail("data was undefined");
}
export function parseDocument(document) {
    // This takes the first operation definition in the document
    var operationDefinition = getOperationAST(document, undefined);
    if (!operationDefinition) {
        return Either.left("No Operation was found in the GraphQL Document.");
    }
    // When a query document is provided we need to
    if (operationDefinition.operation === "query") {
        return Either.right({
            query: document,
            subscription: changeOperationOnDocument(document, OperationTypeNode.SUBSCRIPTION),
        });
    }
    if (operationDefinition.operation === "subscription") {
        return Either.right({
            query: changeOperationOnDocument(document, OperationTypeNode.QUERY),
            subscription: document,
        });
    }
    return Either.left("The 1st operation in the provided GraphQL document was not a query or a subscription.");
}
export function stringToDocument(doc) {
    return gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), doc);
}
export function changeOperationOnDocument(document, operationName) {
    // We have a query document. We need to make a subscription document.
    var dirtyDocument = visit(document, {
        enter: function (node) { return (__assign(__assign({}, node), { operation: operationName })); },
    });
    var loc = print(dirtyDocument);
    var cleanDocument = stringToDocument(loc);
    return cleanDocument;
}
/**
 * @NOTE This function uses React Hooks so the same
 * rules for hooks also apply to this function.
 */
export function useQueryWithResult(document, options) {
    var queryResult = useQuery(document, options);
    var result = queryResultToResult(queryResult);
    return __assign(__assign({}, queryResult), { result: result });
}
/**
 * @NOTE This function uses React Hooks so the same
 * rules for hooks also apply to this function.
 */
export function useLazyQueryWithResult(document, options) {
    var _a = useLazyQuery(document, options), query = _a[0], queryResult = _a[1];
    var result = queryResultToResult(queryResult);
    return [query, __assign(__assign({}, queryResult), { result: result })];
}
var templateObject_1;
